precision highp float;

uniform sampler2D tDiffuse;
uniform float uStrength;
uniform float uRand;

varying vec2 vUv;

const int ITERATIONS = 60;

#pragma glslify: blendHardLight = require(glsl-blend/hard-light)

float circularP(vec2 uv, float dist, float seed, float bias, float offset) {
  float ang = atan(uv.y, uv.x) + sin(dist + 4.1 * seed) * (1.2 - offset) * 2.0;
  ang += 3.14159 * (3.1 * seed);
  return clamp((sin((ang) * (13.0 + offset * float(ITERATIONS))) + bias) / (1.0 + bias), 0.0, 1.0);
}

void main() {
  vec4 col = texture2D(tDiffuse, vUv);

  vec2 uv = vUv * 2.;

  float dist = length(uv * 1.8);
  vec3 colDust = vec3(0.0);

  for (int i = 0; i < ITERATIONS; i++) {
    float offset = float(i) * 2. / float(ITERATIONS) * 2.2;
    vec2 pan = vec2(-uRand, 0.);
    float maskA = circularP(uv, dist, 1.0 * float(i), -0.999, offset);
    float dist2 = length(uv * 3.2 + pan);
    float maskB = circularP(uv + pan, dist2, 12.0 * float(i), -.7, offset);
    float mask = maskA * maskB;
    colDust = mix(colDust, vec3(1.), mask);
  }

  gl_FragColor = vec4(blendHardLight(col.rgb, colDust * 2.0, uStrength), 1.);
}